import styled, { css } from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 10px;
`;

const StyledIconContainer = styled.div<{
	$isHelp: boolean;
	$isReport: boolean;
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	border-radius: 10px;
	transition: background-color 0.3s ease;
	background-color: ${({ $isHelp, $isReport }) =>
		$isReport ? '#C71E1E' : $isHelp ? '#FABE2C' : 'rgba(0, 0, 0, 0.5)'};

	${({ $isHelp }) =>
		$isHelp &&
		css`
			img {
				filter: invert(1);
			}
		`}
`;

export { StyledContainer, StyledIconContainer };
